import type {Vector2} from "@k/js/delme_globals";
import {THREE} from "@k/js/resource/three";

import type {PartSelObShaderInfoProvider} from "@k/js/shader/PartSelObShaderInfoProvider";

export class SelObShaderUniformCreator {
    public selectableObjectTextures: Vector2[] = [];
    public selectableObjectTexturesSize: Vector2[] = [];
    public selObMargins: Vector2[] = [];
    public selObMatrices: THREE.Matrix3[] = [];
    public selObRepeat: number[] = [];
    public selObClampToColor: number[] = [];
    public selObWasserzeichen: number[] = [];
    public selObWasserzeichenInvertImage: number[] = [];
    public selObWasserzeichenIntensity: number[] = [];

    public addSelOb(selobOrPattern: PartSelObShaderInfoProvider) {
        this.selectableObjectTextures.push(selobOrPattern.getTexture());
        this.selectableObjectTexturesSize.push(new THREE.Vector2(selobOrPattern.textureSize.x, selobOrPattern.textureSize.y));
        this.selObMargins.push(new THREE.Vector2(selobOrPattern.margin.x, selobOrPattern.margin.y));
        this.selObMatrices.push(selobOrPattern.getMatrixAbsCanvasFromAbsUV());
        this.selObRepeat.push(selobOrPattern.repeat ? 1 : 0);
        this.selObClampToColor.push(selobOrPattern.clampToColor);
        this.selObWasserzeichen.push(selobOrPattern.wasserzeichen ? 1 : 0);
        this.selObWasserzeichenInvertImage.push(selobOrPattern.wasserzeichenInvertImage ? 1 : 0);
        this.selObWasserzeichenIntensity.push(selobOrPattern.wasserzeichenIntensity);
    }

    isEmpty = () => this.selectableObjectTextures.length === 0;

    getShaderUniformObject() {
        return {
            "SelectableObjectTexture": {type: "tv", value: this.selectableObjectTextures},
            "SelectableObjectTextureSize": {type: "v2v", value: this.selectableObjectTexturesSize},
            "selObMatrices": {type: "m3v", value: this.selObMatrices},
            "selObMargins": {type: "v2v", value: this.selObMargins},
            "selObRepeat": {type: "iv1", value: this.selObRepeat},
            "selObClampToColor": {type: "iv1", value: this.selObClampToColor},
            // "SelObIndexIsTackleTwill": {type: "iv1", value: indizesOfTackleTwillObjects},
            // "selObWasserzeichen": {type: "iv1", value: this.selObWasserzeichen},
            // "selObWasserzeichenInvertImage": {type: "iv1", value: this.selObWasserzeichenInvertImage},
            // "selObWasserzeichenIntensity": {type: "fv1", value: this.selObWasserzeichenIntensity}
        }
    }

    private static getSelObUniformShaderDefinition() {
        return `
uniform sampler2D  SelectableObjectTexture[AnzSelectableObjects];
uniform vec2      SelectableObjectTextureSize[AnzSelectableObjects];
uniform int       SelObIndexIsTackleTwill[AnzSelectableObjects];
uniform mat3      selObMatrices[AnzSelectableObjects];
uniform vec2      selObMargins[AnzSelectableObjects];
uniform int       selObRepeat[AnzSelectableObjects];
uniform int       selObClampToColor[AnzSelectableObjects];
// uniform int       selObWasserzeichen[AnzSelectableObjects];
// uniform int       selObWasserzeichenInvertImage[AnzSelectableObjects];
// uniform float     selObWasserzeichenIntensity[AnzSelectableObjects];
`;
    }

}